import script from "./PortfolioUser.vue?vue&type=script&lang=ts&setup=true"
export * from "./PortfolioUser.vue?vue&type=script&lang=ts&setup=true"

import "./PortfolioUser.vue?vue&type=style&index=0&id=74ae57ee&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74ae57ee"]])

export default __exports__